/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************************!*\
  !*** ./src/js/_announcement-counter.js ***!
  \*****************************************/
(function () {
  var intervalId = null;
  var unixTimestamp = 0;
  var targetDate = new Date();
  function addZero(num) {
    return num < 10 ? "0".concat(num) : num;
  }
  function setCurrentDuration() {
    var now = new Date();
    var diff = targetDate - now;
    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(diff % (1000 * 60) / 1000);
    if (diff <= 0) {
      clearInterval(intervalId);
      days = 0;
      hours = 0;
      minutes = 0;
      seconds = 0;
    }
    var counterEl = document.querySelector('.announcement__countdown_timer_text');
    if (counterEl) {
      counterEl.innerHTML = "".concat(addZero(days), "D : ").concat(addZero(hours), "H : ").concat(addZero(minutes), "M : ").concat(addZero(seconds), "S");
    }
    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  }
  var counterListener = function counterListener() {
    var unixEl = document.querySelector('.announcement__countdown_timer_text');
    if (unixEl) {
      unixTimestamp = unixEl.getAttribute('data-counter-unix-timestamp');
      targetDate = new Date(unixTimestamp * 1000);
      setCurrentDuration();
      intervalId = setInterval(function () {
        setCurrentDuration();
      }, 1000);
    }
  };
  document.addEventListener('DOMContentLoaded', counterListener);
})();
/******/ })()
;